import assign from 'lodash/assign'
import mixpanel from 'mixpanel-browser'
import { filter } from 'utils'

import pendo from './pendo'
import debug from 'debug'
const log = debug('app:clients/analytics')

const LzAnalytics = {
  initialize(settings = {}) {
    assign(LzAnalytics, {
      ...settings,
      logged_in: settings.current_user_id !== null,
    })

    log('Initializing LzAnalytics')

    mixpanel.init(LzAnalytics.mixpanel_token, {
      autocapture: false,
      ignore_dnt: true,
    })
    const pendoPromise = loadPendo()

    return pendoPromise
  },

  appendCommonProperties(properties = {}) {
    const commonProperties = {
      'Auth type': LzAnalytics.auth_type,
      'impersonator id': LzAnalytics.impersonator_id,
      'session read only': LzAnalytics.session_read_only,
      source_pipeline: 'mixpanel.js',
      id: LzAnalytics.current_user_id,
      $id: LzAnalytics.current_user_id,
      // guid mixpanel uniques by
      $user_id: LzAnalytics.current_user_id,
      user_agent: navigator.userAgent,
      ...LzAnalytics.current_user_traits,
      ...LzAnalytics.current_customer_traits,
      ...properties,
    }
    // drop null/empty values
    return filter(commonProperties, (val) => val != null)
  },

  track(event, eventProperties, options = {}) {
    if (!LzAnalytics.premium_customer || LzAnalytics.auth_type === 'Anonymous') {
      return Promise.resolve()
    }

    const properties = LzAnalytics.appendCommonProperties(eventProperties)
    mixpanel.track(event, properties)
    pendo.track(event, eventProperties)
    return Promise.resolve()
  },

  identify(userId, traits) {
    if (!LzAnalytics.premium_customer) return

    mixpanel.identify(userId)
    mixpanel.people.set({ ...traits, 'User ID': userId })
  },

  increment(trait, count) {
    if (LzAnalytics.premium_customer && LzAnalytics.current_user_id) {
      mixpanel.people.increment(trait, count)
    }
  },

  clear_residual_traits() {
    if (LzAnalytics.logged_in) return

    mixpanel.reset()
  },
}

// Pages where the Pendo resource center should not appear. These are short-lived
// auth-bridge pages (the Google scope picker and the OAuth-completion popup) where
// the resource-center widget is visual noise and can overlap the primary controls.
const PENDO_SUPPRESSED_PATHS = [
  '/google_classroom/auth_initiations/new',
  '/google_classroom/customer_auth_completions/new',
]

function loadPendo() {
  if (PENDO_SUPPRESSED_PATHS.includes(window.location.pathname)) return Promise.resolve()

  if (LzAnalytics.current_user_traits && LzAnalytics.current_user_traits['Account type'] === 'user') {
    return pendo.load(
      LzAnalytics.pendo_api_key,
      { userId: LzAnalytics.current_user_id, ...LzAnalytics.current_user_traits },
      LzAnalytics.current_customer_traits,
    )
  }

  return Promise.resolve()
}

export default LzAnalytics
